import { plainAxiosInstance, securedAxiosInstance } from "../axios";

class AuthService {
  signin(user) {
    return plainAxiosInstance.post("/user/sessions", {
      ...user,
    });
  }

  signup(params) {
    return plainAxiosInstance.post("/user/registrations", params);
  }

  signout() {
    return securedAxiosInstance.delete("/user/sessions");
  }

  resetPassword(id, params) {
    return plainAxiosInstance.patch(`/user/password_resets/${id}`, params);
  }

  requestMagicLink(email) {
    return plainAxiosInstance.post(`/user/magic_link`, { email });
  }

  magicSignIn(token) {
    return plainAxiosInstance.post(`/user/sessions/magic_sign_in`, { token });
  }
}

export default new AuthService();
